import { isSpeechRecognitionSupported } from "@jugl-web/utils/speechRecognition";

/**
 * Checks if voice mode (ASR) is supported in the current browser.
 */
export const isVoiceModeSupported = () => {
  return isSpeechRecognitionSupported() && !isBraveBrowser();
};

const isBraveBrowser = () => {
  return !!navigator.brave;
};

declare global {
  interface Navigator {
    brave?: unknown;
  }
}
